import { render, staticRenderFns } from "./sales-channel-selection.vue?vue&type=template&id=0ea572f4&scoped=true&lang=pug"
import script from "./sales-channel-selection.vue?vue&type=script&lang=ts"
export * from "./sales-channel-selection.vue?vue&type=script&lang=ts"
import style0 from "./sales-channel-selection.vue?vue&type=style&index=0&id=0ea572f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea572f4",
  null
  
)

export default component.exports